import { render, staticRenderFns } from "./edit-single-setting-modal.vue?vue&type=template&id=295e2ed4&scoped=true&"
import script from "./edit-single-setting-modal.js?vue&type=script&lang=js&"
export * from "./edit-single-setting-modal.js?vue&type=script&lang=js&"
import style0 from "./edit-single-setting-modal.scss?vue&type=style&index=0&id=295e2ed4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295e2ed4",
  null
  
)

export default component.exports